import { createAction, props } from '@ngrx/store';

import { MenuItem } from '@domain/types';
import * as ActionTypes from './menu-items.actionTypes';

export const loadMenuItems = createAction(ActionTypes.LOAD_MENU_ITEMS);
export const updateMenuItems = createAction(ActionTypes.CHANGE_ITEMS, props<{ menuItem: MenuItem; firsLevelNavigation: boolean }>());
